<script setup>
import { Icon } from '@iconify/vue'

defineProps({ item: { type: Object, default: undefined }, level: { type: Number, default: 0 } })
</script>

<template>
  <v-list-item
    v-scroll-to="{ el: '#top' }"
    :to="item.type === 'external' ? '' : item.to"
    :href="item.type === 'external' ? item.to : ''"
    rounded
    exact
    :disabled="item.disabled"
    :target="item.type === 'external' ? '_blank' : ''"
  >
    <template #prepend>
      <Icon
        :icon="'solar:' + item.icon"
        height="18"
        width="18"
        :level="level"
        class="dot"
        :class="'text-' + item.BgColor"
      />
    </template>
    <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
    <v-list-item-subtitle
      v-if="item.subCaption"
      class="text-caption mt-n1 hide-menu"
    >
      {{ item.subCaption }}
    </v-list-item-subtitle>
    <template
      v-if="item.chip"
      #append
    >
      <v-chip
        :color="item.chipColor"
        :class="'sidebarchip hide-menu bg-' + item.chipBgColor"
        size="x-small"
        :variant="item.chipVariant"
        :prepend-icon="item.chipIcon"
      >
        {{ item.chip }}
      </v-chip>
    </template>
  </v-list-item>
</template>
